import { styled } from "styled-components";
const ChatLoading = () => {
  return (
    <StyledContainer>
      <img
        alt="avatar"
        src={"images/smart-search/chat/OG.gif"}
        className="avatar"
      />
    </StyledContainer>
  );
};

export default ChatLoading;

const StyledContainer = styled.div`
  margin-right: 10px;
  margin-bottom: 10x;
  border-radius: 15px;
  background: #fff;
  padding: 10px;
  img {
    width: 30px;
    height: 30px;
  }
`;
